module.exports = __webpack_public_path__ + "img/web-atm.c1162909.svg";